module.exports = __webpack_public_path__ + "img/image-card-people.c7a4c301.png";